import { useMemo } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogClose,
  cn,
} from '@sib/ui';
import { X } from '@sib/ui/icons';
import { useDialogStore } from '@spendbrain/common/stores';
import { DialogScreen } from '@spendbrain/common/stores/dialog-store';
import { CreateTicketForm } from '@spendbrain/modules/tickets/components';
import { ContractsTable } from '@spendbrain/modules/vendors/components';

export const SpendbrainDialog = () => {
  const { opened: openElement, closable, close } = useDialogStore();

  const dialogComponent = useMemo(() => {
    if (openElement?.component === DialogScreen.CreateTicket)
      return {
        component: <CreateTicketForm />,
      };
    if (openElement?.component === DialogScreen.VendorContracts)
      return {
        component: <ContractsTable {...openElement.componentProps} />,
      };
  }, [openElement]);

  const handleDialogClose = () => {
    close();
    openElement?.onClose?.();
  };

  return (
    <>
      <Dialog
        open={!!openElement}
        onOpenChange={open => !open && closable && handleDialogClose()}
      >
        <DialogContent
          className={cn(
            'flex max-h-[90vh] max-w-[95vw] flex-col overflow-y-auto px-3 py-5 sm:max-w-[90vw] sm:px-[50px]',
            openElement?.DialogContentProps?.className
          )}
        >
          <DialogHeader className="flex flex-row justify-between">
            <DialogTitle className="text-primary text-xl font-semibold">
              {openElement?.dialogTitle}
            </DialogTitle>
            <DialogClose onClick={handleDialogClose} disabled={!closable}>
              <X
                className={cn(
                  'text-primary mb-2 size-3 cursor-pointer',
                  !closable && 'cursor-default opacity-50'
                )}
              />
            </DialogClose>
          </DialogHeader>

          {dialogComponent?.component}
        </DialogContent>
      </Dialog>
    </>
  );
};
